export const initialState = {
  ':db/id': null,
  reactions: [],
  topPosts: []
}
